export default function index() {
  return (
    <>
      <p>
        This document is an electronic record in terms of the Information
        Technology Act, 2000 and shall be deemed to be a valid contract formed
        through electronic means.
      </p>
      <p>
        Blupin Technologies Private Limited, a company registered under the
        Indian Companies Act, 2013, which has its registered office of business
        at 5th Floor, Plot No. 115, Sector 44, Gurgaon, Haryana-122003 and
        operating under its trade name ‘Mylo’ (hereinafter referred to as
        “Mylo&quot; or “We” or “Us” or &quot;Our&quot;) is concerned about the
        privacy of its users accessing/using/browsing www.mylofamily.com as well
        as downloading and using the mobile based application, a portal of
        Blupin Technologies Private Limited. The website and the mobile based
        application are hereinafter collectively referred to as the “Mylo Web
        Platforms”. This Privacy Policy (hereinafter referred to as the
        “Policy”) is for the purpose of acquainting You with the manner in which
        Mylo collects, uses and discloses Your information collected through the
        Mylo Web Platforms.
      </p>
      <p>
        The purpose of this Policy, wherever the context so requires
        &quot;You&quot;, “Your” or &quot;User&quot; shall mean any natural or
        legal person who has agreed to become a buyer on the Mylo Web Platforms
        by placing an Order for the purchase of the products or to avail
        services and/or by providing relevant data or uses by way of browsing or
        downloading the Mylo Web Platforms. For the purpose of this Policy,
        wherever the context so requires, “Vendor” shall mean any natural or
        legal person who has agreed to become a seller or service provider on
        the Mylo Web Platforms. Further, for the purpose of this Policy,
        wherever the context so requires, “Order” shall mean the purchase of the
        products or booking any service by the User via the Mylo Web Platforms.
      </p>

      <p>
        We would like to inform that the Policy is subject to change without
        intimation and You shall be required to review the same regularly. The
        protection and security of Your sensitive personal information is one of
        Our top priorities. This Policy discloses Mylo’s practice with respect
        to the information collected from You on Our Platforms. By
        using/downloading the Platforms You agree to accept the terms of this
        Policy as well as Our Terms & Conditions of Use. By accessing or using
        the Mylo Web Platforms You expressly consent to Our use and disclosure
        of Your sensitive personal information in any manner described in this
        Policy. This Policy extends to both, Users who are visiting the Mylo Web
        Platforms but do not transact business on them, as well as Users who are
        registered on the Mylo Web Platforms for using MYLO WEB PLATFORMS
        services and all of their employees and authorised users.
      </p>
      <p>
        BY USING THE MYLO WEB PLATFORMS, YOU AGREE TO THE TERMS AND CONDITIONS
        OF THIS POLICY. IF YOU DO NOT AGREE WITH THE TERMS AND CONDITIONS OF
        THIS POLICY, PLEASE DO NOT PROCEED FURTHER TO USE THE MYLO WEB
        PLATFORMS. PLEASE READ THE FOLLOWING TERMS OF OUR PRIVACY POLICY:
      </p>
      <h3>PLEASE READ THE FOLLOWING TERMS OF OUR PRIVACY POLICY: </h3>
      <h3>
        1) COLLECTION OF PERSONALLY IDENTIFIABLE INFORMATION AND OTHER
        INFORMATION
      </h3>
      <p>
        1.1. “Personal information&quot; means any information that relates to a
        natural person, which, either directly or indirectly, in combination
        with other information available or likely to be available with a body
        corporate, is capable of identifying such person.
      </p>
      <p>
        1.2. “Sensitive personal data or information” of a person means such
        personal information which consists of information relating to —
        password, financial information such as Bank account or credit card or
        debit card or other payment instrument details, physical, physiological
        and mental health condition, sexual orientation, medical records and
        history, Biometric information, any detail relating to the above clauses
        as provided to body corporate for providing service, and any of the
        information received under above clauses by body corporate for
        processing, stored or processed under lawful contract or otherwise. The
        Personal Information and Sensitive personal data or information are
        hereinafter collective referred to as “Sensitive Personal Information”.
      </p>
      <p>
        1.3. We only collect your, Sensitive Personal Information, including
        your health and medical information with your explicit, unconditional,
        and informed consent. Your consent will be specific to the intended use
        of your data. We will not share your health and medical information with
        any third party without your further explicit consent, except: As
        required by law or legal process. To protect your vital interests or the
        vital interests of others. To comply with regulatory requirements. To
        provide healthcare services through collaborating healthcare providers
        (with strict confidentiality agreements in place).
      </p>
      <p>
        1.4. When You use Our Platforms, We collect and store Your Sensitive
        Personal Information which is provided by You from time to time as per
        the applicable laws. Our primary goal in doing so is to provide You a
        safe, efficient, smooth and customized experience. This allows Us to
        provide services and features that most likely meet Your needs, and to
        customize Our Platforms to make Your experience safer and easier. More
        importantly, while doing so We collect Sensitive Personal Information
        from You that We consider necessary for achieving this purpose.
      </p>
      <p>
        1.5. In general, You can browse the website and/or download the mobile
        application without telling Us who You are or revealing any Sensitive
        Personal Information about Yourself. Once You give Us Your Sensitive
        Personal Information, You are not anonymous to Us. Where possible, We
        indicate which fields are required and which fields are optional. You
        always have the option to not provide information by choosing not to use
        a particular service or feature on the Platforms. We may automatically
        track certain information about You based upon Your behaviour on Our
        Platforms. We use this information to do internal research on Our
        users&apos; demographics, interests, and behaviour to better understand,
        protect and serve Our Users. This information may include the URL that
        You just came from (whether this URL is on Our website or not), which
        URL You next go to (whether this URL is on Our website or not), Your
        computer browser information and Your IP address, the software You are
        using on Your mobile phone on which You download the mobile application,
        Your location, name, mobile number etc.
      </p>
      <p>
        1.6. You acknowledge that apart from Your Sensitive Personal
        Information, if You upload any content on the Mylo Web Platforms in the
        form of reviews, recommendations, ratings, comments or any other form,
        such content may contain information including Sensitive Personal
        Information and the same may be available to the other Users of the Mylo
        Web Platforms. Mylo will not be liable for the disclosure and
        dissemination of such Sensitive Personal Information to third parties.
      </p>
      <p>
        1.7. Mylo may disclose aggregated information about the use of the Mylo
        Web Platforms, but it will never contain Sensitive Personal Information.
        Mylo does not disclose Sensitive Personal Information to third parties
        in the normal course of operations. However, in situations when Mylo is
        legally obligated to disclose information to the government or other
        third parties, Mylo will do so.
      </p>
      <p>
        1.8. Mylo implements reasonable and standard measures to protect against
        unauthorized access to and unlawful interception of Sensitive Personal
        Information.
      </p>
      <p>
        1.9.You are required to submit Your information at the time of placing
        an Order on the Mylo Web Platforms. Mylo uses an online payment gateway
        that is operated by a third party and the information that You share
        with Mylo is transferred and shared with such third party payment
        gateway operator. The said operator may also have access to Your online
        purchase history/details that You make from the Mylo Web Platforms.
      </p>
      <p>
        1.10. If You are using Mylo through Our mobile application, We may use
        Your mobile device ID (the unique identifier assigned to a device by the
        manufacturer), instead of cookies, to recognize You. We may do this to
        store Your preferences and track Your use of Our applications. Unlike
        cookies, mobile device IDs cannot be deleted. Advertising companies may
        use device IDs to track Your use of Our applications, track the number
        of advertisements displayed, measure advertising performance and display
        advertisements that are more relevant to You. Analytics companies may
        use mobile device IDs to track Your usage of Our applications. The
        online or offline status of Your application can also be viewed and
        stored by Us.
      </p>
      <p>
        1.11. Mylo may collect information about the presence and/ or absence
        and/ or details pertaining to other applications on Your mobile phone.
        The applications we gather information for, may vary across categories
        including, without limitation, shopping, fashion, food and travel. This
        will help Us understand You and Your preferences better and enable Mylo
        to provide You with a personalised experience.
      </p>
      <p>
        1.12. Extremely sensitive information like Your credit-card details are
        transacted upon secure sites of approved payment gateways which are
        digitally under encryption, thereby providing the highest possible
        degree of care as per current technology. You are advised, however, that
        internet technology is not 100% safe and You should exercise discretion
        in using the same
      </p>
      <h3>2) INFORMATION YOU PROVIDE TO US </h3>
      <p>
        2.1. Your account information: Your profile picture that will be
        publicly displayed as part of Your account profile. You may optionally
        provide Us with this information through third-party sign-in services
        such as Facebook and Google Plus. In such cases, We fetch and store
        whatever information is made available to Us by You through these
        sign-in services.
        <p>
          2.2. Your preferences: Your preferences and settings such as time zone
          and language.
        </p>
        <p>
          2.3. Your content: the Information You provide through the Mylo Web
          Platforms, including Your name, email address, age, address (including
          country and ZIP/postal code, gender, reviews, photographs, comments,
          lists, current and prior Order details etc.
        </p>
        <p>
          2.4. Your searches and other activities: The search terms You have
          looked up and results You selected.
        </p>
        <p>
          2.5. Your browsing information: How long You used the Mylo Web
          Platforms and which features You used; the ads You clicked on.
        </p>
        <p>
          2.6. Your communications: Communications between You and other Users
          or Vendors through the Mylo Web Platforms, Your participation in a
          survey, poll, contest or promotion scheme; Your request for certain
          features (e.g., newsletters, updates or other products); Your
          communication with Us through the chat feature available on the
          website as well as mobile application. You agree that any
          communication by way of email, phone call or chat with Our
          representative, other Users and Vendors will be recorded and stored.
          This is mainly done to customize Your experience while using the Mylo
          Web Platforms in the future, and for quality and training purposes.
        </p>
        <p>
          2.7. Your transactional information (like bank account details, GST
          certificate, PAN Card, etc.): If You make purchases or avail services
          through the Mylo Web Platforms, We may collect and store information
          about You to process Your requests and automatically complete forms
          for future transactions, including (but not limited to) Your phone
          number, address, Geographical location through the IP address, email,
          billing information and credit or payment card information.
        </p>
        <p>
          2.8. Your other personally identifiable information/details as You may
          share from time to time (including personally identifiable
          information/details of Your customer/buyer).
        </p>
        <p>
          2.9. Your Public Posts: You may also provide information (such as
          ratings, reviews, tips, photos, comments, likes, bookmarks, friends,
          lists, etc.) to be published or displayed (hereinafter,
          &quot;posted&quot;) on publicly accessible areas of the Mylo Web
          Platforms, or transmitted to other Users of the Mylo Web Platforms or
          third-parties (collectively, &quot;User Contributions&quot;). Your
          User Contributions are posted on and transmitted to others at Your own
          risk. Although We limit access to certain pages, You may set certain
          privacy settings for such information by logging into Your account
          profile. Please be aware that no security measures are perfect or
          impenetrable. Additionally, We cannot control the actions of other
          Users of the Mylo Web Platforms with whom You may choose to share Your
          User contributions. Therefore, We cannot and do not guarantee that
          Your User contributions will not be viewed by unauthorized persons. We
          may display this information on the Mylo Web Platforms, share it with
          businesses, and further distribute it to a wider audience through
          third party sites and services. You should be careful about revealing
          any sensitive details about yourself in such postings.
        </p>
      </p>
      {/* start from here */}
      <h3>3) LINKS TO THIRD PARTY PLATFORMS </h3>
      <p>
        3.1. Mylo may contain links to other websites on the website which are
        operated by third parties and are not controlled by, or affiliated to,
        or associated with Mylo, unless expressly specified on the website. Mylo
        is not responsible for any form of transmission, whatsoever, received by
        You from any linked site. Accordingly, Mylo does not make any
        representations concerning the privacy practices or policies of such
        third parties or terms & conditions of such websites, nor does Mylo
        control or guarantee the accuracy, integrity, or quality of the
        information, data, text, software, photographs, graphics, videos,
        messages or other materials available on such websites. The inclusion or
        exclusion does not imply any endorsement by Mylo of the website, the
        website&apos;s provider, or the information on the website. The
        information provided by You to such third party websites shall be
        governed in accordance with the privacy policies of such websites and it
        is recommended that You review the privacy policy on any such websites
        prior to using such websites. These third-party websites and advertisers
        may use technology to send the advertisements that appear on the Website
        directly to Your browser. In such cases, the third party websites or
        advertisers automatically receive Your IP address. They may also use
        cookies, JavaScript, web beacons and other technologies to measure the
        effectiveness of their advertisements and to personalize advertising
        content. Mylo does not have access to or control over cookies or other
        features that such third party websites and advertisers may use, and the
        information practices of these third-party websites and advertisers are
        not covered by this Policy. Please contact them directly for more
        information about their privacy practices.
      </p>
      <p>
        3.2. Email and Push Notification communication: The following sets forth
        attribution notices for third party software that may be contained in
        portions of the Mylo application. OneSignal Partnership Notwithstanding
        anything else in this policy, we may work with partners who use mobile
        SDKs, including the OneSignal Messaging SDK, to passively collect
        information (collectively, “SDK Information”), which generally helps us
        deliver personalized notifications. This data may also be used to
        identify you in a unique manner across other devices or browsers for the
        purposes of customizing ads or content. Depending on the permissions
        granted to this application, this information may include personally
        identifiable information (PII) including your email address. This
        information may also include precise location (i.e. GPS-level data) or
        WiFi information, apps you have installed and enabled, and your mobile
        identifier (e.g., Android Advertising ID).
      </p>
      <p>
        3.3 Consumer Control & Opt-Out Options
        <br /> a) Opting-out of OneSignal Push Notifications You may in most
        cases opt out of receiving push notifications by going to your device
        “Settings” and clicking on “Notifications,” and then changing those
        settings for some or all of the apps on your device. (Different device
        configurations, or updates to devices, may affect or change how these
        settings work.) <br />
        b) Opting Out of “Cross-App” Advertising on Mobile Devices You can opt
        out of having your mobile advertising identifiers used for certain types
        of interest-based (also called “cross-app”) mobile behavioral
        advertising, by accessing the “settings” on your Apple or Android mobile
        device, as follows: By opening the Google Settings app on your device,
        selecting Ads, and then selecting the option to opt-out of
        interest-based ads. (Different device configurations, or updates to
        devices, may affect or change how these settings work.)
      </p>
      <h3>4) COOKIES AND OTHER ELECTRONIC TOOLS </h3>
      <p>
        4.1. We, and third parties with whom we partner, may use cookies, pixel
        tags, web beacons, mobile device IDs, “flash cookies” and similar files
        or technologies to collect and store information in respect to Your use
        of the Mylo Web Platforms and third party websites. A cookie is a small
        text file that is stored on Your computer that enables Us to recognize
        You (for example, as a registered User) when You visit Our website,
        store Your preferences and settings, enhance Your experience by
        delivering content and advertising specific to Your interests, perform
        research and analytics, track Your use of the Mylo Web Platforms, and
        assist with security and administrative functions. A pixel tag (also
        called a web beacon or clear GIF) is a tiny graphic with a unique
        identifier, embedded invisibly on a webpage (or an online ad or email),
        and is used to count or track things like activity on a webpage or ad
        impressions or clicks, as well as to access cookies stored on Users’
        computers. Mylo uses pixel tags to measure the popularity of Our various
        pages, features and services. We also may include web beacons in e-mail
        messages or newsletters to determine whether the message has been opened
        and for other analytics.
        <p></p>
      </p>
      <p></p>
      <p>
        4.2. Most browsers are set to automatically allow cookies. Please note
        it may be possible to disable some (but not all) cookies through Your
        device or browser settings, but doing so may interfere with certain
        functionality on the Mylo Web Platforms. Major browsers provide Users
        with various options when it comes to cookies. Users can usually set
        their browsers to block all third-party cookies (which are those set by
        third-party companies collecting information on websites operated by
        other companies), block all cookies (including first-party cookies such
        as the ones Mylo uses to collect search activity information about its
        Users), or block specific cookies. To modify Your cookie settings,
        please visit Your browser’s help settings. Flash cookies operate
        differently than browser cookies and cannot be removed or blocked via
        web browser settings. By using the Mylo Web Platforms with Your browser
        set to accept cookies, You are consenting to Our use of cookies in the
        manner described in this section.
      </p>
      <p>
        4.3. Third parties whose products or services are accessible or
        advertised through the Mylo Web Platforms, including social media
        services, may also use cookies or similar tools, and We advise You to
        check their privacy policies for information about their cookies and
        other practices. We do not control the practices of such partners and
        their privacy policies govern their interactions with You.
      </p>
      <p>
        4.4. If You transact with Us, We collect some additional information,
        such as a billing address, a credit / debit card number and a credit /
        debit card expiration date and/ or other payment instrument details and
        tracking information from cheques or money orders.
      </p>
      <p>
        4.5. If You choose to post messages on Our message boards, chat rooms or
        other message areas or leave feedback, we will collect that information
        You provide to Us. We retain this information as necessary to resolve
        disputes, provide customer support and troubleshoot problems as
        permitted by law.
      </p>
      <h3>5) USAGE OF INFORMATION WE COLLECT </h3>
      <p>
        5.1. We may share Sensitive Personal Information with Our other
        corporate entities and affiliates. These entities and affiliates may
        market to You as a result of such sharing unless You explicitly opt-out.
      </p>
      <p>
        5.2. We may disclose Sensitive Personal Information to third parties.
        This disclosure may be required for Us to provide You access to Our
        Platforms, to comply with Our legal obligations, to facilitate Our
        marketing and advertising activities, or to prevent, detect, mitigate,
        and investigate fraudulent or illegal activities related to the Mylo Web
        Platforms. You acknowledge and accept that this disclosure is necessary
        to make this experience as great for You as possible and consent to our
        disclosure as envisaged above.
      </p>
      <p>
        5.3. We may disclose Sensitive Personal Information if required to do so
        by law or in the good faith belief that such disclosure is reasonably
        necessary to respond to summons, court orders, or other legal process.
        We may disclose Sensitive Personal Information to law enforcement
        offices, third party rights owners, or others in the good faith belief
        that such disclosure is reasonably necessary to enforce Our Terms or
        Privacy Policy, respond to claims that an advertisement, posting or
        other content violates the rights of a third party, or protect the
        rights, property or personal safety of Our Users or the general public.
      </p>
      <p>
        5.4. We and Our affiliates will share / sell some or all of Your
        Sensitive Personal Information with another business entity should We
        (or Our assets) plan to merge with, or be acquired by that business
        entity, or reorganization, amalgamation, restructuring of business.
        Should such a transaction occur that other business entity (or the new
        combined entity) will be required to follow this privacy policy with
        respect to Your Sensitive Personal Information.
      </p>
      <p>
        5.5. Further, We use the information We collect from and about You for a
        variety of purposes, including to: <br />
        5.5.1. Process and respond to Your queries <br /> 5.5.2. Understand Our
        Users (what they do on the Mylo Web Platforms, what features You like,
        how You use them, etc.),
        <br /> 5.5.3. Improve the content and features of the Mylo Web Platforms
        (such as by personalizing content to Your interests),
        <br /> 5.5.4. Process and complete Your transactions, and make special
        offers.
        <br /> 5.5.5. Administer Our services and diagnose technical problems.
        <br /> 5.5.6. Send You communications that You have requested or that
        may be of interest to You.
        <br /> 5.5.7. Send You questions from other Users that You may be able
        to answer if You have registered with Mylo.
        <br />
        5.5.8. Enable Us to show You ads that are relevant to You.
        <br />
        5.5.9. Generate and review reports and data about, and to conduct
        research on, Our user base and Mylo Web Platform usage patterns.
        <br /> 5.5.10. Provide You with customer support.
        <br /> 5.5.11. Provide You with notices about Your account.
        <br /> 5.5.12. Carry out Our obligations and enforce Our rights arising
        from any contracts entered into between You and Us, including for
        billing and collection.
        <br /> 5.5.13. Notify You about changes to Our services.
        <br /> 5.5.14. Allow You to participate in interactive features offered
        through the Mylo Web Platforms.
        <br /> 5.5.15. In any other way We may describe when You provide the
        information.
        <br />
        5.5.16. For any other purpose with Your consent.
      </p>
      <p>
        5.6. We may also use Your information to contact You about third-party
        products and services that may be of interest to You.
      </p>
      <h3>6) WITHDRAWAL OF CONSENT</h3>
      <p>
        You have the right to withdraw your consent at any time for the
        collection, use, or disclosure of your sensitive information, including
        health and medical information. You can do so by contacting us through
        grievance@mylofamily.com. <br /> Please note that withdrawing your
        consent may impact your ability to access certain features or services
        offered on our platform.
      </p>
      <h3>7) OUR DISCLOSURE OF YOUR INFORMATION </h3>
      <p>
        7.1. Except as provided in this Privacy Policy, we do not sell or rent
        any personally identifiable information or any sensitive personal data
        and information about You or Your customers to any third party, other
        than for internal Platform development and maintenance. The following
        describes some of the ways that your information may be disclosed, and
        you hereby agree that the Company may disclose such information without
        requirement for any further consent from you at any point of time.
      </p>
      <p>
        7.2. Service Providers: We may share Your information with outside
        service providers that We use for a variety of purposes, such as to send
        You emails and messages on behalf of other Mylo members, push
        notifications to Your mobile device on Our behalf, provide voice
        recognition services to process Your spoken queries and questions, help
        Us analyze use of the Mylo Web Platforms, and process and collect
        payments. Some of Our products, services and databases are hosted by
        third party hosting services providers. We also may use vendors for
        other projects, such as conducting surveys or organizing sweepstakes for
        Us. We may share information about You with these vendors only to enable
        them to perform their services.
      </p>
      <p>
        7.3. Legal Purposes: We may share Your information when We believe in
        good faith that such sharing is reasonably necessary in order to
        investigate, prevent, or take action regarding possible illegal
        activities or to comply with legal process. We may also share Your
        information to investigate and address threats or potential threats to
        the physical safety of any person, to investigate and address violations
        of this Privacy Policy or the Terms of Service, or to investigate and
        address violations of the rights of third parties and/or to protect the
        rights, property and safety of Mylo, Our employees, Users, or the
        public. This may involve the sharing of Your information with law
        enforcement, government agencies, courts, and/or other organizations on
        account of legal request such as summons, court order or government
        demand to comply with the law.
      </p>
      <p>
        7.4. Social Networks: If You interact with social media features on the
        Mylo Web Platforms, such as the Facebook Like button, or use Your social
        media credentials to log-in or post content, these features may collect
        information about Your use of the Mylo Web Platforms, as well as post
        information about Your activities on the social media service. Your
        interactions with social media companies are governed by their privacy
        policies.
      </p>
      <p>
        7.5. If We believe disclosure is necessary or appropriate to protect the
        rights, property, or safety of Mylo, Our customers or others. This
        includes exchanging information with other companies and organizations
        for the purposes of fraud protection and credit risk reduction.
      </p>
      <p>
        7.6. When You place an Order on the Mylo Web Platforms, the information
        You provide to Us, is shared with the Vendor with whom You choose to
        transact. In order to facilitate Your Order, We provide Your information
        to that Vendor in a similar manner as if You had placed an Order
        directly with the Vendor. If You provide a mobile phone number, Vendors
        or Mylo may send You text messages regarding Your Order or Order’s
        delivery status. Some Vendors also require You to provide credit or
        debit card account information to secure Your Order. When You place an
        Order through the Mylo Web Platforms and/or make a payment to a through
        the Mylo Web Platforms, We may also share with the Vendors additional
        information, such as information about Your preferences and history or
        information that We collect from third-parties.
      </p>
      <p>
        7.7. We may share Sensitive Personal Information with other corporations
        or individuals, whether situated in India or elsewhere, subject to the
        condition that: (a) the recipient guarantees a level of data protection
        equivalent to that maintained by our Company; (b) such transfers are
        essential for fulfilling the contractual obligation between the Company
        or its authorized representatives and the data provider; and (c) an
        explicit consent in respect of the said transfer has been provided by
        You.
      </p>
      <p>
        7.8. Payment Card Information: To use the Mylo Web Platforms, We may
        require credit or debit card account information. By submitting Your
        credit or debit card account information, You expressly consent to the
        sharing of Your information with Vendors, third-party payment
        processors, and other third-party service providers (including but not
        limited to vendors who provide fraud detection services to Us and other
        third parties).
      </p>
      <h3>8) ASSESSING, REVIEWING AND CHANGING YOUR PROFILE </h3>
      <p>
        8.1. We will take reasonable steps to accurately record the Sensitive
        Personal Information that You provide to Us and any subsequent updates.
      </p>
      <p>
        8.2. We encourage You to review, update, and correct the Sensitive
        Personal Information that We maintain about You, and You may request
        that We delete Sensitive Personal Information about You that is
        inaccurate, incomplete, or irrelevant for legitimate purposes, or are
        being processed in a way which infringes any applicable legal
        requirement.
      </p>
      <h3>9) SECURITY PRECAUTIONS </h3>
      <p>
        9.1. We have implemented appropriate physical, electronic, and
        managerial procedures to safeguard and help prevent unauthorized access
        to Your information and to maintain data security. These safeguards take
        into account the sensitivity of the information that We collect, process
        and store and the current state of technology. We follow generally
        accepted industry standards to protect the Sensitive Personal
        Information submitted to Us. However, no method of transmission over the
        Internet or via mobile device, or method of electronic storage, is 100%
        secure. Therefore, while We strive to use commercially acceptable means
        to protect your Sensitive Personal Information, We cannot guarantee its
        absolute security and thereby usage in a manner that is inconsistent
        with this Policy.
      </p>
      <p>
        9.2. We assume no liability or responsibility for disclosure of Your
        information due to errors in transmission, unauthorized third-party
        access, or other causes beyond Our control. You play an important role
        in keeping Your Sensitive Personal Information secure. You should not
        share Your user name, password, or other security information for Your
        Mylo account with anyone. If We receive instructions using Your user
        name and password, We will consider that You have authorized the
        instructions.
      </p>
      <p>
        9.3. Notwithstanding anything contained in this Policy or elsewhere,
        Mylo shall not be held responsible for any loss, damage or misuse of
        Your Sensitive Personal Information, if such loss, damage or misuse is
        attributable to a Force Majeure Event (as defined below).
      </p>
      <p>
        9.4. A &quot;Force Majeure Event&quot; shall mean any event that is
        beyond the reasonable control of Mylo and shall include, without
        limitation, sabotage, fire, flood, explosion, acts of God, civil
        commotion, strikes or industrial action of any kind, riots,
        insurrection, war, acts of government, computer hacking, unauthorised
        access to computer data and storage devices, computer crashes, breach of
        security and encryption, etc.
      </p>
      <h3>10) CHANGES TO THIS POLICY </h3>
      <p>
        We reserve the right to amend this Policy from time to time to reflect
        changes in the law, Our data collection and use practices, the features
        of the Mylo Web Platforms, or advances in technology. Please check this
        page periodically for changes. Use of information We collect is subject
        to this Policy in effect at the time such information is used. If We
        make any material changes to this Policy, We will post the changes on
        the Mylo Web Platforms. Please review the changes carefully. Your
        continued use of the Mylo Web Platforms following the posting of changes
        to this Policy will constitute Your consent and acceptance of those
        changes.
      </p>
      <h3>11) GRIEVANCE REDRESSAL POLICY </h3>
      <p>
        We shall take every effort to give Users a comfortable and personal
        experience on the Mylo Web Platform. Despite this if you as a User have
        any complaint with respect to; <br />
        (a) information privacy <br />
        (b) content of other users <br /> (c) any other reasonable grievance{' '}
        <br />
        You may communicate the same with us by contacting our Grievance
        Redressal Officer whose details are as follows:
        <br /> <br />
        Address to: Vikram Singh 5th Floor, Plot No. 115, Sector 44, Gurgaon,
        Haryana-122003
        <br />
        Email: grievance@mylofamily.com
      </p>
      <h3>12) GENERAL PROVISIONS </h3>
      <p>
        By accessing Our Platforms, You have agreed to the terms set out in this
        Policy. This Policy should be at all times read along with the Terms &
        Conditions of use of the Mylo Web Platforms. Unless stated otherwise,
        the Policy applies to all information that Mylo has about You and Your
        account. Any disputes arising under this Policy shall be governed by the
        laws of India and the Courts in Gurugram, Haryana shall have exclusive
        jurisdiction.
      </p>

      {/* <PrivacyPolicies /> */}
    </>
  );
}
